import React from 'react';
import { Building2, HardHat, Shield, Sparkles, Wind, PartyPopper } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { services } from '../data/mockData';

const iconMap = {
  Building2,
  HardHat,
  Shield,
  Sparkles,
  Wind,
  PartyPopper
};

const Services = () => {
  return (
    <section id="services" className="py-32 bg-gray-50">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-20">
          <h2 className="text-4xl font-bold mb-4 text-gray-900">
            Nuestros Servicios
          </h2>
          <p className="text-lg text-gray-600">
            Soluciones integrales de limpieza diseñadas para cada necesidad
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            
            return (
              <div 
                key={service.id}
                className="bg-white rounded-lg p-8 border border-gray-200 hover:border-[#7030A0] transition-all duration-300 group"
                style={{
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(112, 48, 160, 0.5)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'white';
                }}
              >
                <div className="mb-6">
                  <IconComponent size={32} className="text-[#2E75B6] group-hover:text-white transition-colors" />
                </div>
                <h3 className="text-xl font-semibold mb-3 text-gray-900 group-hover:text-white transition-colors">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed group-hover:text-white transition-colors">
                  {service.description}
                </p>
                
                <ul className="space-y-2">
                  {service.features.map((feature, index) => (
                    <li 
                      key={index}
                      className="flex items-center text-sm text-gray-700 group-hover:text-white transition-colors"
                    >
                      <span className="w-1 h-1 rounded-full bg-[#2E75B6] group-hover:bg-white mr-3 transition-colors" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
